import React from "react";
import { useParams } from "react-router-dom";
import RootShortcutOutfit from "container/shortcutOutfit/RootShortcutOutfit";
import AppUpdateCheckpoint from "container/common/AppUpdateCheckpoint";

function ShortcutOutfitPage(props) {
  const params = useParams();

  return (
    <AppUpdateCheckpoint>
      <RootShortcutOutfit outfitHash={params.outfitHash} />
    </AppUpdateCheckpoint>
  );
}

export default ShortcutOutfitPage;
